"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecurringInterval = exports.DayOfWeek = exports.BookingRecurringRuleStatus = void 0;
var BookingRecurringRuleStatus = /*#__PURE__*/function (BookingRecurringRuleStatus) {
  BookingRecurringRuleStatus["Active"] = "active";
  BookingRecurringRuleStatus["Canceled"] = "canceled";
  return BookingRecurringRuleStatus;
}({});
exports.BookingRecurringRuleStatus = BookingRecurringRuleStatus;
var DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  DayOfWeek["Sunday"] = "sunday";
  DayOfWeek["Monday"] = "monday";
  DayOfWeek["Tuesday"] = "tuesday";
  DayOfWeek["Wednesday"] = "wednesday";
  DayOfWeek["Thursday"] = "thursday";
  DayOfWeek["Friday"] = "friday";
  DayOfWeek["Saturday"] = "saturday";
  return DayOfWeek;
}({});
exports.DayOfWeek = DayOfWeek;
var RecurringInterval = /*#__PURE__*/function (RecurringInterval) {
  RecurringInterval["Week"] = "week";
  return RecurringInterval;
}({});
exports.RecurringInterval = RecurringInterval;